"use client";
import { useState, useEffect, useLayoutEffect } from "react";

// useLayoutEffect fires synchronously before paint on the client, eliminating
// the desktop→mobile layout flash that useEffect causes on mobile devices.
// The SSR fallback to useEffect avoids the "useLayoutEffect on server" warning.
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

export function useBreakpoint() {
  const [width, setWidth] = useState(1200);

  useIsomorphicLayoutEffect(() => {
    const update = () => setWidth(window.innerWidth);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return {
    // A phone narrower than 480px cannot fit the nav's text links beside the
    // account trigger; the links move into the account menu there (Nav.tsx).
    isNarrow: width < 480,
    isMobile: width < 768,
    isTablet: width >= 768 && width < 1024,
    isDesktop: width >= 1024,
    width,
  };
}
